import { render, staticRenderFns } from "./cadEscala.vue?vue&type=template&id=c0c02ca4&scoped=true&"
import script from "./cadEscala.vue?vue&type=script&lang=js&"
export * from "./cadEscala.vue?vue&type=script&lang=js&"
import style0 from "./cadEscala.vue?vue&type=style&index=0&id=c0c02ca4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c02ca4",
  null
  
)

export default component.exports